/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Code_RequiredInputs */

const en_delete_account_code_required = /** @type {(inputs: Delete_Account_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code is required.`)
};

const es_delete_account_code_required = /** @type {(inputs: Delete_Account_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código de verificación es obligatorio.`)
};

const ar_delete_account_code_required = /** @type {(inputs: Delete_Account_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز التحقق مطلوب.`)
};

/**
* | output |
* | --- |
* | "Verification code is required." |
*
* @param {Delete_Account_Code_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_code_required = /** @type {((inputs?: Delete_Account_Code_RequiredInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Code_RequiredInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_code_required(inputs)
	if (locale === "es") return es_delete_account_code_required(inputs)
	return ar_delete_account_code_required(inputs)
});